import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import AephoriaTable from '../comps/aephoriaTable';
import * as aserver from '../../APIClient';
import Modal from '../comps/modal';
import Button from '@material-ui/core/Button';
import Toast from "../comps/alertMessage";
import Switch from '@material-ui/core/Switch';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AlertModal from "../comps/alertModal";
import { getTeamReportDownloadLinks } from "../../Utilities";
import LoadingBackdrop from '../comps/loadingBackdrop';
import editIcon from '../images/Pencil.png'
import deleteIcon from '../images/Trash.png'
import downloadIcon from '../images/Download.png'
import * as utils from "../../Utilities";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
  note:{
    color: "red !important",
    marginTop: "0",
  }
}));

class TeamMembers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coachId: localStorage.getItem('Id'),
      modalIsOpen: false,
      memberComments: "",
      teamsId: "",
      teamId: localStorage.getItem("teamID"),
      teamName: localStorage.getItem("Team-Name"),
      level: "",
      message: "",
      membersUuid: "",
      teamLeader: "",
      allClients: [],
      modalClients:[],
      selected: 0,
      checked: null,
      alertModalTitle: "",
      alertMessage: "",
      openAlertModal: false,
      confirmationFunction: this.confirmationFunction,
      confirmationModal: false,
      dueDate: "",
      minDate: "",
      openModal: false,
      reportTypeRequested: "Not Requested",
      reportRequestDueDate: "",
      allTeams: [],
      showModalCancelButton: false,
      disableRequestButton: false,
      disableCancelButton: true,
      requestModalText: "",
      requestModal: false,
      showResponseModal:false,
      responseMessage:"",
      members:[],
      openBackdrop:false,
      otherDataExists: null,
      addMembersModal:false,
      openWarningModal:false,
      addMembersToTeamUUIDS: null,
      teamReportNames: {},
      addToTeamDisabled: false,
    };
  }

  componentDidMount = () => {
    this.setState({
      teamId: localStorage.getItem("teamID"),
    });
    this.fetchTeamInfo()
    document.addEventListener("keydown", this.escFunction, false);
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closeModal()
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  showToast = () => {
    this.setState(
      {
        showToast: true
      },
      () => {
        setTimeout(() => this.setState({ showToast: false }), 1500);
      }
    );
  }

  makeInfoTile = (record) => {
    return(<>{record.displayName}<br/>{record.clientEmail}</>);
  }

  reloadPage = () => {
    window.location.reload(false)
  }
  
  refreshTable = () => {
    this.setState({
      key: Math.random() // will reload the Team Members table.
    })
  }

  toastMessage = (text, level) => {
    this.setState({
      modalIsOpen: false,
      message: text,
      level: level
    })
    this.showToast()
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      openAlertModal: false,
      confirmationModal: false,
      openModal: false,
      showModalCancelButton: false,
      requestModal: false,
      showResponseModal:false,
      openBackdrop:false,
      addMembersModal:false
    });
  }

  blankCoach = () => {
    this.setState({
      name: '',
      description: '',
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onChangeValue = (event) => {
    this.setState({ teamLeader: event.target.value })
  }

  selectedData = (data) => {
    this.setState({
      selected: data
    })
  }

  handleToggle = (record) => async (event) => {
    if(this.state.reportRequestDueDate){
      this.openAlertModal("Please note", "You cannot edit membership of a team for which a report has already been requested or issued. Rather make a duplicate of this team, edit the members, and then request a new report for the duplicated team.")
      return  
    }
    const { teamId, allClients } = this.state;

    this.setState({
      checked: event.target.checked,
    });

    let clientId = record.uuid;
    let newObject = allClients.findIndex((obj => obj.uuid === clientId))
    allClients[newObject].teamLeaderToggle = <span className="teamLeaderColumn"><Switch checked={event.target.checked} onChange={this.handleToggle(record)} /> </span>;

    let updated = await aserver.put(`api/v2/teams/${teamId}/members/${record.uuid}`, {
      isTeamLeader: event.target.checked,
    })
    if (updated.status !== 200) {
      this.openAlertModal("Failed", updated.data.error.info)
    }

  };

  massageData = (data, modal) => {
    if(!modal)
    this.setState({
      allClients: data,
    })
    else
    this.setState({
      modalClients:data
    })
    for (let record of data) {

      aserver.convertUTCToLocal(record, 'completedAt');
      aserver.convertUTCToLocal(record, 'guestCompletedAt');

      record.assessmentType = utils.assessmentCodeToName(record.assessmentType);


      record.displayName = [record.clientName, ' ', record.clientSurname].join("")
      record.enneaResult = [record.userEnnea, ' ', record.orderedTriType, ' ', record.userInstinct].join("")
      // record.imfResult = [record.scoreIMF]

      if(record.otherData){
        this.setState({
          otherDataExists:true
        })
      }
      let r = [];
      if (record.userEnnea || record.userTriType || record.userInstinct) {
        r.push(record.userEnnea);
        r.push(record.userTriType);
        r.push(record.userInstinct);
      }
      record.results = r.join(' ');

      if (r[2] === null) {
        record.results = ""
      }

      let newInfoTile = record.displayName;


      record.infoTile = this.makeInfoTile(record)
      record.infoTileSearchableText = record.displayName + " "+ record.clientEmail;

      record.newInfoTile = newInfoTile;

      Object.assign(record, { teamLeaderToggle: <span className="teamLeaderColumn"><Switch checked={record.isTeamLeader === 1} onChange={this.handleToggle(record)} /></span> })    }
  }

 openEdit = (uuid) => {
  this.clientInfoFunc(uuid);
  this.setState({
    modalIsOpen: true,
    membersUuid: uuid,
    }, () => {
      const memberComments = document.getElementById('memberComments');
      if (memberComments) {
        memberComments.focus();
      }}
   );
  }

  editMembers = async () => {
    const { memberComments, teamId, membersUuid, allClients } = this.state;
    let updated = await aserver.put(`api/v2/teams/${teamId}/members/${membersUuid}`, {
      memberComments: memberComments,
    })
    if (updated.status !== 200) {
      this.openAlertModal("Failed", updated.data.error.info)
    } else {
      let clientId = membersUuid.join("");
      let newObject = allClients.findIndex((obj => obj.uuid === clientId))
      allClients[newObject].memberComments = memberComments;
      this.closeModal()
    }
  }

  clientInfoFunc = (id) => {
    const { allClients } = this.state;
    let result = allClients.find(({ uuid }) => uuid === id.toString());
      this.setState({
        memberComments: !result.memberComments?"":result.memberComments,
        teamLeader: result.teamLeaderToggle
      })
    }

  openAlertModal = (title, message) => {
    this.closeModal()
    this.setState({
      alertModalTitle: title,
      alertMessage: message,
      openAlertModal: true,
    })
  }

  goBack = () => {
    aserver.goto('/coachportal/teams');
  }

  //========================= New buttons functionality=========================

  checkForTeamLeaders = async () => {
    let latestUpdatedLeadersList = await aserver.get(`api/v2/teams/${this.state.teamId}/members`)
    let findLeaders = latestUpdatedLeadersList.data.filter(({ isTeamLeader }) => isTeamLeader === 1).length
    this.setState({
      showModalCancelButton: true,
      showResponseModal:false
    })
    if (findLeaders === 1) {
      this.previousDateRemoved()
      this.openRequestTeamReportModal()
    } else {
      this.previousDateRemoved()
      this.setState({
        confirmationModal: true,
        confirmationHeading: "Confirmation",
        confirmationFunction: () => this.openRequestTeamReportModal(),
      })
      if (findLeaders === 0) {
        this.setState({
          confirmationModalText: `This team has no leader - are you sure you want to request the team report?`
        })
      } else {
        this.setState({
          confirmationModalText: `This team has ${findLeaders} leaders - are you sure you want to request the team report?`
        })
      }
    }
  }

  openRequestTeamReportModal = () => {
    this.setState({
      confirmationModal: false,
      teamsModalTitle: "Request Team Report",
      teamsModalSubmitCaption: 'Request report',
      openModal: true,
      disableRequestButton: !this.state.reportType,
    })
  }

  onChangeValue = (event) => {
    this.setState({ 
      reportType: event.target.value,
      disableRequestButton: false,
     })
  }

  requestTeamReport = async () => {
      if (this.state.dueDate >= this.state.minDate) {
        this.setState({
          teamsModalTitle: "Requesting Team Report...",
          disableRequestButton: true,
        })
          let request = await aserver.post(`api/v2/teams/${this.state.teamId}/requestReport`,
            {
              reportRequested: this.state.reportType,
              reportDueDate: this.state.dueDate
            });
          if (request.status === 200) {
            this.setState({
              reportTypeRequested: request.data.reportRequestedDisplay,
              reportRequestDueDate: this.state.dueDate.slice(0, 10),
              disableCancelButton: false,
              openBackdrop: true,
            })
            if (request.data.reportReady) {
              this.reloadPage();
            } else {
              this.setState({
                openModal: false,
                requestModal: true,
                requestModalText: "The report has been requested and will be made available for download as soon as possible.",
                openBackdrop: false
              })
            }
          } else {
            this.openAlertModal("Failed", request.data.error.info)
            this.setState({
              disableRequestButton: false,
            })
          }
  
      }
      else if (this.state.dueDate <= this.state.minDate) {
        this.toastMessage("Your due date cannot be today or any day before today", "danger")
      }
      else {
        this.toastMessage("You cannot have 0 members", "danger")
      }
  }

  checkIfTeamIsADuplicate = async()=>{
    if(this.state.duplicatedSourceId){
      let checkResponse = await aserver.get(`api/v2/teams/${this.state.teamId}/teamReportChargeInfo`)
      this.setState({
        showResponseModal:true,
        responseMessage:checkResponse.data.message,
        isFreeOfCharge: checkResponse.data.isFreeOfCharge
      })
    }else{
      this.checkForTeamLeaders()
    }
  }

  changeDate = (event) => {
    this.setState({
      dueDate: event.target.value.slice(0, 10)
    });
  }

  cancelTeamReport = async () => {
    let cancel = await aserver.get(`api/v2/teams/${this.state.teamId}/cancelReportRequest`);
    if (cancel.status === 200) {
      this.setState({
        disableRequestButton: false,
        disableCancelButton: true,
      })
      this.reloadPage()
    }
    else {
      this.openAlertModal("Failed", cancel.data.error.info)
    }

  }

  downloadSummary = async () => {
    let downloadSummary = await aserver.download(`api/v2/teams/${this.state.teamId}/downloadSummary`)
    if (downloadSummary.status === 200) {
      this.toastMessage("Downloading...", "success")
    } else {
      this.openAlertModal("Failed", "Failed")
    }
  }


  previousDateRemoved = () => {
    var today = new Date();
    var dd = String(today.getDate() + 1).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;

    this.setState({
      minDate: today.slice(0, 10)
    })
  }

  fetchTeamInfo = async () => {
    let getTeamInfo = await aserver.get(`api/v2/coaches/${this.state.coachId}/teams`)
    const result = getTeamInfo.data.find(({ uuid }) => uuid === this.state.teamId);
    if (result.reportDueDate) {
      this.setState({
        disableRequestButton: true,
        disableCancelButton: false,
        reportTypeRequested: result.reportRequestedDisplay,
        reportRequestDueDate: result.reportDueDate.slice(0, 10),
      });
    } else {
      this.setState({
        disableRequestButton: false,
        disableCancelButton: true,
      });
    }
    this.setState({
      teamReportNames: result.teamReportNames,
      isReportAvailable: result.isReportAvailable,
      reportRequested: result.reportRequested,
      offerReportPDF: result.offerReportPDF,
      offerReportPPTX: result.offerReportPPTX,
      duplicatedSourceId: result.duplicatedSourceId
    })

  }

  downloadReportLink = () => {
    var record = {
      uuid: this.state.teamId,
      isReportAvailable: this.state.isReportAvailable,
      reportRequested: this.state.reportRequested,
      offerReportPDF: this.state.offerReportPDF,
      offerReportPPTX: this.state.offerReportPPTX
    }
    return (getTeamReportDownloadLinks(this, record, aserver));
  }

  addMembersModal = ()=>{
    if (this.state.reportRequestDueDate) {
      this.openWarningModal("Please note", "You cannot add members to a team for which a report has already been requested or issued. You can make a duplicate of this team, add and edit its members, and then request a new report for the duplicated team.");
      return;
    }
    this.setState({
      addMembersModal:true,
      addMembersToTeamUUIDS: null,
      addToTeamDisabled: false,
    })
  }

  addToTeam =()=>{
    const { addMembersToTeamUUIDS, teamId, modalClients, allClients} = this.state;
    if ((!addMembersToTeamUUIDS)||(addMembersToTeamUUIDS.length===0)) {
      this.openWarningModal("Please note", "Select members to add to the team.");
      return;
    }
    const selectedAssessments = (modalClients || []).filter(c => addMembersToTeamUUIDS.includes(c.uuid));
    const duplicateEmails = utils.findDuplicateTeamMemberEmails(selectedAssessments, allClients);
    if (duplicateEmails.length > 0) {
      this.openWarningModal("Please note", utils.duplicateTeamMemberEmailMessage(duplicateEmails));
      return;
    }
    this.setState({ addToTeamDisabled: true });
    utils.addTeamMembers(this, teamId, addMembersToTeamUUIDS, true);
  }

  openWarningModal =  (title, message) =>{
    this.setState({
      warningTitle: title,
      warningMessage:message,
      openWarningModal:true,
    })    
  }

  closeOnlyOneModal=()=>{
    this.setState({
      openWarningModal:false,
    })
  }

  onSelectionChanged = (addMembersToTeamUUIDS) => {
    this.setState({addMembersToTeamUUIDS})
  }

  render() {
    const classes = this.props.classes;
    const ReportLink = this.downloadReportLink();
    let otherData = { dataField: "otherData", caption: "Other" };
    let routeStub = `api/v2/coaches/${this.state.coachId}/tokensX`;
    let route = {
      callback: async function () {
        let ownAssessments = (await aserver.get(routeStub)).data;
        let scoAssessments = (await aserver.get(`${routeStub}?mode=received`)).data;
        return { data: ownAssessments.concat(scoAssessments) };
      }
    };
    return (

        <main className="app-content">

                <div className="topHeading">
                  <h3 style={{ margin: "0", paddingTop: "1.35vh" }}>Team Report</h3>
                  <Button variant="contained" color="primary" onClick={this.goBack}><ArrowBackIcon /> Back</Button>
                </div>
                <p style={{marginTop:"0", display: this.state.isReportAvailable? "none" : "block" }}><span className={classes.note} >Note:</span> Please plan for up to two working days between your report request and delivery of the report. While we try to deliver the report immediately, it can sometimes take longer, especially for larger teams.</p>
                <div className="teamMember-grid">
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.checkIfTeamIsADuplicate()} disabled={!this.state.isReportAvailable ? this.state.disableRequestButton : true}>Request Team Report</Button>
                  <span style={{ margin: "0.1vw" }}> </span>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.cancelTeamReport()} disabled={!this.state.isReportAvailable ? this.state.disableCancelButton : true}>Cancel Team Report</Button>
                  <span>
                    {this.state.reportTypeRequested !== 'Not Requested'
                      ? 'Report: '
                      : 'Report request: '}
                    <span className="requestedTeamReportInfo">{this.state.reportTypeRequested}</span>
                  </span>
                  {this.state.reportRequestDueDate ? <span style={{ display: this.state.isReportAvailable? "none" : "block" }}>Due date: <span className="requestedTeamReportInfo"> {this.state.reportRequestDueDate} </span></span> : null}
                  {this.state.reportRequestDueDate ? <span>Report links:<br></br> <span className="requestedTeamReportInfo">{ReportLink}</span></span> : null}
                </div>
                <h3 style={{ margin: "0.5vw 0 0" }}>Team Members</h3>
                <AephoriaTable
                  key={this.state.key}
                  route={`api/v2/teams/${this.state.teamId}/members`}
                  massageData = {(data)=>this.massageData(data, false)}
                  selectedData={this.selectedData}
                  filterButtons={[]}
                  pageSize={this.state.allClients.length}
                  deleteConfig={
                    {
                      endpoint: `api/v2/teams/${this.state.teamId}/members`,
                      pluralDisplayName: "Teams Members",
                      displayCallback: function(record) {
                        return(record.displayName)
                      },
                      disabledDeleteCheck: () => !!this.state.reportRequestDueDate,
                      disabledDeleteTooltip: 'You cannot remove members from a team for which a report has already been requested or issued. Make a duplicate of this team, edit the members, and request a new report for the duplicated team.'
                    }
                  }
                  tableFunctions={[
                    { caption: 'Add Members', icon: editIcon, frequentlyUsed: true, minRecordsRequired: 0, ourownonclick: this.addMembersModal },
                    { caption: 'Edit', icon: editIcon, frequentlyUsed: true, minRecordsRequired: 1, maxRecordsRequired: 1, ourownonclick: this.openEdit },
                    { caption: 'Delete', icon: deleteIcon, frequentlyUsed: true, minRecordsRequired: 1 },
                    { caption: 'Download summary', icon: downloadIcon, frequentlyUsed: true, minRecordsRequired: 0, ourownonclick: this.downloadSummary },
                  ]}
                  tableName="Teams"
                  displayFields={[{ dataField: "infoTile", caption: "Info" }, { dataField: "userCoach", caption: "Project" }, { dataField: "userCompany", caption: "Company" }, { dataField: "userOccupation", caption: "Position  " }, { dataField: "assessmentType", caption: "Assessment" }, { dataField: "enneaResult", caption: "Ennea Results" }, { dataField: "scoreIMF", caption: "Maturity Results" }, { dataField: "teamLeaderToggle", caption: "Team Leader" }, { dataField: "memberComments", caption: "Comments" }, { dataField: "completedAt", caption: "Completed" },...(this.state.otherDataExists ? [otherData] : [])]} />
                <Modal id="editCommentModal" isOpen={this.state.modalIsOpen} onClose={() => this.closeModal()}>
                  <h3>Edit Team Member</h3>
                  <div>
                  <div>
                      <textarea rows="5" maxlength="250" cols="50" id="memberComments" name="memberComments" onChange={this.handleChange } value={this.state.memberComments} style={{ "width": "100%" }} />
                  </div>
                  </div>
                  <Button variant="contained" color="primary" type="submit" onClick={this.editMembers}>Save Changes</Button>
                </Modal>
                <Toast
                  level={this.state.level}
                  message={this.state.message}
                  visible={this.state.showToast}
                />

                <Modal isOpen={this.state.confirmationModal} onClose={() => this.closeModal()}>
                  <h3>{this.state.confirmationHeading}</h3>
                  <p>{this.state.confirmationModalText}</p>
                  <ul style={{"margin-left":"-1.5vw"}}>{this.state.members.map(displayName => {return (<li>{displayName} </li>)})}</ul>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.state.confirmationFunction(true)}>Yes</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>No</Button>
                  {this.state.showModalCancelButton ? <Button variant="contained" color="primary" type="submit" onClick={() => this.closeModal()}>Cancel</Button> : null}
                </Modal>

                {/*===================== Report request modal =====================*/}
                <Modal isOpen={this.state.openModal} onClose={this.state.disableRequestButton ? null : () => this.closeModal()}>
                  <h3>{this.state.teamsModalTitle}</h3>
                  <div check>
                    <input
                      type="radio"
                      value="Ennea"
                      checked={this.state.reportType === "Ennea"}
                      onChange={this.onChangeValue}
                    />
                    <span style={{ marginLeft: "5px" }}>{this.state.teamReportNames.ennea}</span>
                  </div>
                  <div check>
                    <input
                      type="radio"
                      value="IMf"
                      disabled={localStorage.getItem("hasMaturityAccreditation") !== "1"}
                      checked={this.state.reportType === "IMf"}
                      onChange={this.onChangeValue}
                    />
                    <span style={{ marginLeft: "5px" }}>{this.state.teamReportNames.EIT}</span>
                  </div>
                  <div check>
                    <input
                      type="radio"
                      value="Full"
                      disabled={localStorage.getItem("hasMaturityAccreditation") !== "1"}
                      checked={this.state.reportType === "Full"}
                      onChange={this.onChangeValue}
                    />
                    <span style={{ marginLeft: "5px" }}>{this.state.teamReportNames.full}</span>
                  </div>
                  <br></br>
                  <div>
                    <span>Due Date:</span><br></br>
                    <input type="date" id="date-picker" name="requestDate" min={this.state.minDate} max="2999-12-31" onChange={this.changeDate} />
                  </div>
                  <Button variant="contained" color="primary" type="submit" disabled={this.state.disableRequestButton} onClick={() => this.requestTeamReport()}>{this.state.teamsModalSubmitCaption}</Button>
                  <p style={{ display: this.state.teamsModalTitle === "Requesting Team Report..." ? "block" : "none" }}>Please wait for the request to be processed...</p>
                </Modal>

                <Modal isOpen={this.state.requestModal} onClose={() => this.reloadPage()}>
                  <h3>Report Request</h3>
                  {this.state.requestModalText}
                  <br /><br />
                  <Button variant="contained" color="primary" type="submit" onClick={this.reloadPage}>Ok</Button>
                </Modal>

                <Modal isOpen={this.state.showResponseModal} onClose={() => this.closeModal()}>
                  <h3>Note</h3>
                  <p id="responeMessage" style={{whiteSpace: 'pre'}}>{this.state.responseMessage}</p>
                  <br /><br />
                  <Button variant="contained" color="primary" type="submit" onClick={this.checkForTeamLeaders}>Proceed</Button>
                  <Button variant="contained" color="primary" type="submit" onClick={this.closeModal}>Cancel</Button>

                </Modal>
                <Modal id='addMembersModal' isOpen={this.state.addMembersModal} onClose={() => this.closeModal()}>
                  <h3 style={{"margin":"0"}}>Add Members to Team</h3>
                  <AephoriaTable
                        key={this.state.key}
                        route={route}
                        massageData = {(data)=>this.massageData(data, true)}
                        selectedData ={this.selectedData}
                        onSelectionChanged= {this.onSelectionChanged} 
                        filterButtons={[]}
                        deleteConfig={[]}
                        tableFunctions={[]}
                        tableName="Assessments"
                        displayFields={[{ dataField: "infoTile", caption: "Name" },{ dataField: "clientCompany", caption: "Company" },
                          { dataField: "userCoach", caption: "Project" },{ dataField: "results", caption: "Ennea" },
                          { dataField: "scoreIMF", caption: "Maturity" },{ dataField: "guestCompletedAt", caption: "Completed" } ]}
                  />
                  <Button variant="contained" color="primary" type="submit" onClick={this.addToTeam} disabled={this.state.addToTeamDisabled} style={{width:"140px"}}>Add to Team</Button>
                </Modal>

                <AlertModal
                  message={this.state.alertMessage}
                  modalTitle={this.state.alertModalTitle}
                  isOpen={this.state.openAlertModal}
                  showClose={() => this.closeModal()}
                />

                <AlertModal
                  message={this.state.warningMessage}
                  modalTitle={this.state.warningTitle}
                  isOpen={this.state.openWarningModal}
                  showClose={() => this.closeOnlyOneModal()}
                >
          
                </AlertModal>
          <LoadingBackdrop open={this.state.openBackdrop} />
        </main>

    );
  }
}
// eslint-disable-next-line
export default () => {
  const classes = useStyles();
  return (
    <TeamMembers classes={classes} />
  )
};